const isString = (str: unknown): boolean => typeof str === 'string'

/**
 *
 * A function a pluralized a word or entire strings
 *
 * @param str a word or an array of words.
 *
 * If the length of the array is 2, it will be the following format: [singular, plural]
 *
 * If the length of the array is 3, it will be the following format: [zero, singular, plural]
 *
 * @param count quantity to be able to pluralize
 * @param suffix default to 's'. Will be concatenated at the end of str
 *
 * If you use {{count}} in a string, it will be replaced with the value of count
 *
 * @returns a plurized string
 */
const pluralizer = (
  str: string | string[],
  count: number,
  suffix = 's'
): string => {
  let result = ''
  if (typeof str === 'string') result = count > 1 ? `${str}${suffix}` : str
  if (Array.isArray(str) && str.every(isString) && str.length === 2) {
    const [singular, plural] = str
    result = count > 1 ? plural : singular
  }
  if (Array.isArray(str) && str.every(isString) && str.length === 3) {
    const [zero, singular, plural] = str

    switch (count) {
      case 0:
        result = zero
        break
      case 1:
        result = singular
        break
      default:
        result = plural
        break
    }
  }
  return result.replace('{{count}}', `${count}`)
}

export default pluralizer
